/*
 * Public API Surface of ngn-multi-select
 */

export * from "./lib/ngn-multi-select.component";
export * from "./lib/ngn-multi-select.module";
